import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    VNavigationDrawer,
    {
      ref: "NestedDrawer",
      staticClass: "nested-drawer",
      attrs: { permanent: "", width: _vm.drawerWidth },
    },
    [
      _c(
        "div",
        { staticClass: "nested-drawer__inner" },
        [
          _c(
            VNavigationDrawer,
            {
              staticClass: "nested-drawer__menu",
              attrs: {
                "mini-variant": "",
                "mini-variant-width": _vm.menuWidth,
                permanent: "",
                dark: "",
                color: "primary",
              },
            },
            [
              _c("v-menu-list", {
                staticClass: "nested-drawer__menu-list",
                attrs: { flat: "", items: _vm.items },
                model: {
                  value: _vm.activeItem,
                  callback: function ($$v) {
                    _vm.activeItem = $$v
                  },
                  expression: "activeItem",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "nested-drawer__content" },
            [
              _c(
                _vm.activeItemComponent,
                _vm._b({ tag: "component" }, "component", _vm.$attrs, false)
              ),
              _vm._v(" "),
              _c("div", {
                staticClass: "nested-drawer__border",
                staticStyle: { width: "4px", cursor: "ew-resize" },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }